import { render, staticRenderFns } from "./CreateProduction.vue?vue&type=template&id=23cfc176&lang=pug&"
import script from "./CreateProduction.vue?vue&type=script&lang=ts&"
export * from "./CreateProduction.vue?vue&type=script&lang=ts&"
import style0 from "./CreateProduction.vue?vue&type=style&index=0&id=23cfc176&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports